import PureHelloBar from 'components/Common/HelloBar/HelloBar';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import getCurrentCategory from 'store/category/selector/getCurrentCategory';

interface OwnProps {
  cleanupContentStyles: boolean;
}

const HelloBar: FC<OwnProps> = ({ cleanupContentStyles }) => {
  const helloBar = useSelector(getCurrentCategory)?.helloBar;

  if (!helloBar) {
    return null;
  }

  return <PureHelloBar content={helloBar} cleanupContentStyles={cleanupContentStyles} />;
};

export default HelloBar;
